import { ScreenContainerControl } from "doshx_controls_web";
import React, { useState, useEffect } from "react";
import ReactMarkdown from "react-markdown";
import { setMainModal } from "../../reducers/slices/main";
import { useDispatch } from "react-redux";
import { return_policy } from "../../api/calls/client/return_policy";
export const ReturnPolicyPage = (props) => {
    const dispatch = useDispatch();
    const [returnData, setReturnData] = useState("");
    useEffect(() => {
        return_policy().then((response) => {
            if (response.success) {
                setReturnData(response.content.return_policy);
            }
            else {
                dispatch(setMainModal({ title: "Something went wrong!", messages: [response.message] }));
            }
        });
    }, []);
    return (React.createElement("div", { className: "" },
        React.createElement(ScreenContainerControl, null,
            React.createElement("div", { className: "flex flex-col gap-4" },
                React.createElement(ReactMarkdown, null, returnData)))));
};
